import { Customer, PlasticsOrderedProduct, ProductVersion, UploadedFile } from "@prism/prism-shared";

export interface PlasticsSkid {
    id: string;
    orderedProductId: string;
    /** The shipment this skid has been scanned/linked onto, or '' when unlinked. */
    shipmentId: string;
    productId: string;
    productVersionId: string;
    packingLabelId: string;
    quantity: number;
    customerId: string;
    salesOrderNumber: string;
    purchaseOrderNumber: string;
    createdById: string;
    createdOn: Date;
    shippedById: string;
    shippedOn: Date | null;
    length: number;
    width: number;
    height: number;
    weight: number;
    uploadedFiles: UploadedFile[];
    orderedProductCompletedOn: Date | null;
}

export interface DisplayPlasticsSkid {
    skid: PlasticsSkid;
    // can be obsolete
    skidProductVersion: ProductVersion | null;
    orderedProduct: PlasticsOrderedProduct | null;
    endCustomer: Customer | null;
}

export const toDisplayPlasticsSkids = (
    skids: PlasticsSkid[],
    versionIdToSkidProductVersionDict: Record<string, ProductVersion>,
    orderedProducts: PlasticsOrderedProduct[],
    customerDict: Record<string, Customer>,

) => {

    const displaySkids: DisplayPlasticsSkid[] = skids.map((skid) => {

        let version = versionIdToSkidProductVersionDict[skid.productVersionId] || null;

        const orderedProduct = orderedProducts
            .find(op => op.id === skid.orderedProductId) as PlasticsOrderedProduct;


        if (!orderedProduct) {
            return {
                skid,
                orderedProduct: null,
                skidProductVersion: version,
                endCustomer: customerDict[skid.customerId] || null,
            }
        }
        const displayPlasticsSkid: DisplayPlasticsSkid = {
            skid,
            orderedProduct,
            skidProductVersion: version,
            endCustomer: customerDict[skid.customerId] || null,
        }
        return displayPlasticsSkid;
    }).sort((a, b) => {
        // If a has shippedOn and b doesn't, a comes first
        if (a.skid.shippedOn && !b.skid.shippedOn) {
            return -1;
        }
        // If b has shippedOn and a doesn't, b comes first
        if (!a.skid.shippedOn && b.skid.shippedOn) {
            return 1;
        }
        // If both have shippedOn, sort by shippedOn date
        if (a.skid.shippedOn && b.skid.shippedOn) {
            return new Date(a.skid.shippedOn).getTime() - new Date(b.skid.shippedOn).getTime();
        }
        // If neither has shippedOn, sort by createdOn date
        return new Date(a.skid.createdOn).getTime() - new Date(b.skid.createdOn).getTime();
    })
    return displaySkids;
}